const icon = state => state.icon;
const clients = state => state.clients;
const client = state => state.client;
const site = state => state.site;
const sites = state => state.sites;
const building = state => state.building;
const buildings = state => state.buildings;
const plant = state => state.plant;
const plants = state => state.plants;

export default {
  icon,
  clients,
  client,
  sites,
  site,
  buildings,
  building,
  plants,
  plant
};
